// extracted by mini-css-extract-plugin
export default {"line_table_link":"styles_line_table_link__7Vjpa","navigate_table":"styles_navigate_table__UbmRW","search_block":"styles_search_block__zBbFz","calendar":"styles_calendar__gcq94"};